import { useEffect, useMemo, useState } from 'react';
import { adminApi } from '../api';

// Every host that can take a manual session or a transferred booking, grouped by role. Any host with a Google
// calendar (or an email for their primary calendar) can host; only "Directors" are shown to patients on the
// portal — the others are manual-book-only. Ids go to the API as director_id / host_id; the backend resolves
// them from either the directors or pccs collection.
export default function useHostGroups() {
  const [directors, setDirectors] = useState([]);
  const [pccs, setPccs] = useState([]);

  useEffect(() => {
    adminApi.get('/admin/directors').then((r) => setDirectors((r.data.directors || []).filter((d) => d.active !== false))).catch(() => {});
    adminApi.get('/admin/pccs').then((r) => setPccs((r.data.pccs || []).filter((p) => p.active !== false))).catch(() => {});
  }, []);

  return useMemo(() => {
    const canHost = (h) => (h.google_calendar_id || '').trim() || (h.email || '').trim();
    const dirs = directors.filter(canHost);
    return [
      { key: 'director', label: 'Directors', items: dirs.filter((d) => (d.role || 'director') === 'director').map((d) => ({ id: d.director_id, name: d.name })) },
      { key: 'pcc', label: 'PCCs', items: pccs.filter(canHost).map((p) => ({ id: p.pcc_id, name: p.name })) },
      { key: 'hc', label: 'Health Coaches', items: dirs.filter((d) => d.role === 'hc').map((d) => ({ id: d.director_id, name: d.name })) },
      { key: 'va', label: 'VAs', items: dirs.filter((d) => d.role === 'va').map((d) => ({ id: d.director_id, name: d.name })) },
    ].filter((g) => g.items.length);
  }, [directors, pccs]);
}
